// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── MigrationDiagram layout ─── */
.md-wrap {
  width: 100%;
  position: relative;
}
.md-svg {
  width: 100%;
  height: auto;
  display: block;
}

/* ══════════════════════════════════════
   FLOW LINE animations (stroke-dashoffset)
═══════════════════════════════════════ */

/* Left lines: pink segment travels left → center */
.md-fl {
  stroke-dasharray: 60 310;
  animation: mdFlowL 2.8s linear infinite;
}
@keyframes mdFlowL {
  from { stroke-dashoffset: 370; }
  to   { stroke-dashoffset: 0;   }
}

/* Right lines: cyan segment travels center → right */
.md-fr {
  stroke-dasharray: 60 310;
  animation: mdFlowR 2.8s linear infinite;
}
@keyframes mdFlowR {
  from { stroke-dashoffset: 370; }
  to   { stroke-dashoffset: 0;   }
}

/* Staggered delays — 5 lines each side */
.md-d0 { animation-delay: 0s;    }
.md-d1 { animation-delay: 0.46s; }
.md-d2 { animation-delay: 0.92s; }
.md-d3 { animation-delay: 1.38s; }
.md-d4 { animation-delay: 1.84s; }

/* ══════════════════════════════════════
   HANGING BADGE float animation
═══════════════════════════════════════ */
.md-badge-float {
  animation: mdBadgeFloat 3s ease-in-out infinite;
}
@keyframes mdBadgeFloat {
  0%,  100% { transform: translateY(0px);  }
  50%       { transform: translateY(-7px); }
}

/* Per-badge delays — staggered so each pill floats independently */
.md-bd0 { animation-delay: 0s;    }
.md-bd1 { animation-delay: 0.55s; }
.md-bd2 { animation-delay: 1.1s;  }
.md-bd3 { animation-delay: 0.28s; }   /* right-side start offset */
.md-bd4 { animation-delay: 0.83s; }
.md-bd5 { animation-delay: 1.38s; }
`, "",{"version":3,"sources":["webpack://./src/components/MigrationDiagram.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;yCAEyC;;AAEzC,mDAAmD;AACnD;EACE,wBAAwB;EACxB,uCAAuC;AACzC;AACA;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,oBAAoB,IAAI;AACjC;;AAEA,qDAAqD;AACrD;EACE,wBAAwB;EACxB,uCAAuC;AACzC;AACA;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,oBAAoB,IAAI;AACjC;;AAEA,yCAAyC;AACzC,SAAS,mBAAmB,KAAK;AACjC,SAAS,sBAAsB,EAAE;AACjC,SAAS,sBAAsB,EAAE;AACjC,SAAS,sBAAsB,EAAE;AACjC,SAAS,sBAAsB,EAAE;;AAEjC;;yCAEyC;AACzC;EACE,+CAA+C;AACjD;AACA;EACE,YAAY,0BAA0B,GAAG;EACzC,YAAY,2BAA2B,EAAE;AAC3C;;AAEA,mEAAmE;AACnE,UAAU,mBAAmB,KAAK;AAClC,UAAU,sBAAsB,EAAE;AAClC,UAAU,qBAAqB,GAAG;AAClC,UAAU,sBAAsB,EAAE,IAAI,4BAA4B;AAClE,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE","sourcesContent":["/* ─── MigrationDiagram layout ─── */\n.md-wrap {\n  width: 100%;\n  position: relative;\n}\n.md-svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* ══════════════════════════════════════\n   FLOW LINE animations (stroke-dashoffset)\n═══════════════════════════════════════ */\n\n/* Left lines: pink segment travels left → center */\n.md-fl {\n  stroke-dasharray: 60 310;\n  animation: mdFlowL 2.8s linear infinite;\n}\n@keyframes mdFlowL {\n  from { stroke-dashoffset: 370; }\n  to   { stroke-dashoffset: 0;   }\n}\n\n/* Right lines: cyan segment travels center → right */\n.md-fr {\n  stroke-dasharray: 60 310;\n  animation: mdFlowR 2.8s linear infinite;\n}\n@keyframes mdFlowR {\n  from { stroke-dashoffset: 370; }\n  to   { stroke-dashoffset: 0;   }\n}\n\n/* Staggered delays — 5 lines each side */\n.md-d0 { animation-delay: 0s;    }\n.md-d1 { animation-delay: 0.46s; }\n.md-d2 { animation-delay: 0.92s; }\n.md-d3 { animation-delay: 1.38s; }\n.md-d4 { animation-delay: 1.84s; }\n\n/* ══════════════════════════════════════\n   HANGING BADGE float animation\n═══════════════════════════════════════ */\n.md-badge-float {\n  animation: mdBadgeFloat 3s ease-in-out infinite;\n}\n@keyframes mdBadgeFloat {\n  0%,  100% { transform: translateY(0px);  }\n  50%       { transform: translateY(-7px); }\n}\n\n/* Per-badge delays — staggered so each pill floats independently */\n.md-bd0 { animation-delay: 0s;    }\n.md-bd1 { animation-delay: 0.55s; }\n.md-bd2 { animation-delay: 1.1s;  }\n.md-bd3 { animation-delay: 0.28s; }   /* right-side start offset */\n.md-bd4 { animation-delay: 0.83s; }\n.md-bd5 { animation-delay: 1.38s; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
